import { CircularProgress, Tooltip } from '@material-ui/core';
import React, { useState } from 'react';
import moment from 'moment';
import DownloadForOfflineOutlinedIcon from '@mui/icons-material/DownloadForOfflineOutlined';
import api from 'api';

const EvalueHeaderContent = ({ lastEvalueUpdate }: any) => {
  const [downloadingCsv, setDownloadingCsv] = useState(false);

  return (
    <>
      <div>
        <h4>Last EV update</h4>
        <div style={{ paddingTop: '8px' }}>
          {moment(lastEvalueUpdate).format('dddd, MMMM Do YYYY')}
        </div>
      </div>
      <div style={{ marginLeft: 'auto' }}>
        <div>
          {downloadingCsv ? (
            <CircularProgress size="20px" />
          ) : (
            <Tooltip title="Download as CSV" arrow>
              <DownloadForOfflineOutlinedIcon
                style={{ cursor: 'pointer', fontSize: 'rem' }}
                onClick={() => {
                  setDownloadingCsv(true);
                  api
                    .downloadReturnForecastsConfig()
                    .then((response: any) => {
                      const url = window.URL.createObjectURL(
                        new Blob([response.data])
                      );
                      const link = document.createElement('a');
                      link.href = url;
                      const file_name = 'forecast-returns.csv';
                      link.setAttribute('download', file_name);
                      document.body.appendChild(link);
                      link.click();
                      setDownloadingCsv(false);
                    })
                    .then(() => {
                      setDownloadingCsv(false);
                    });
                }}
              />
            </Tooltip>
          )}
        </div>
      </div>
    </>
  );
};

export default EvalueHeaderContent;
